import script from "./WorkRoyaltiesTermsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkRoyaltiesTermsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WorkRoyaltiesTermsDialog.vue?vue&type=style&index=0&id=a4905aaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4905aaa"]])

export default __exports__